import React from "react";
import PropTypes from "prop-types";
import fetchJsonp from "fetch-jsonp";
import { AUTH_HOST } from "shared/components/GlobalHeader/navigation/config";
import AuthContext, { initialContextValue } from "./AuthContext";

export default function provideAuth(Component) {
  /* eslint-disable react/no-unused-state */
  class AuthProviderWrapper extends React.Component {
    constructor(props) {
      super(props);

      let initialState = {
        user: {
          ...initialContextValue.user,
          ...(props.auth && props.auth.user),
        },
        isFetching: false,
      };

      if (typeof window !== "undefined" && window.GLOBAL_UI_INITIAL_PROPS) {
        const { auth: serverAuth } = window.GLOBAL_UI_INITIAL_PROPS;

        initialState = {
          ...initialState,
          user: {
            ...initialState.user,
            ...(serverAuth && serverAuth.user),
          },
        };
      }

      initialState.isUserSignedIn = !!initialState.user.id;

      this.state = initialState;
    }

    componentDidMount = async () => {
      const { user } = this.state;

      if (!user.id && typeof window !== "undefined") {
        this.setState({ isFetching: true });

        const response = await fetchJsonp(`${AUTH_HOST}/users/status.json`);
        const payload = await response.json();

        this.setState({
          user: { ...user, ...payload },
          isFetching: false,
          isUserSignedIn: !!payload.id,
        });
      }
    };

    render() {
      return (
        <AuthContext.Provider value={this.state}>
          <Component {...this.props} auth={this.state} />
        </AuthContext.Provider>
      );
    }
    /* eslint-enable react/no-unused-state */
  }

  AuthProviderWrapper.propTypes = {
    auth: PropTypes.shape({
      user: PropTypes.shape({
        id: PropTypes.string,
        email: PropTypes.string,
        username: PropTypes.string,
        avatar: PropTypes.string,
        facebookUid: PropTypes.string,
        profileSlug: PropTypes.string,
        timestamp: PropTypes.string,
        variant: PropTypes.string,
      }),
    }),
  };

  AuthProviderWrapper.defaultProps = {
    auth: {
      user: initialContextValue.user,
    },
  };

  return AuthProviderWrapper;
}
